<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path :d="paths[name] || paths.library" />
  </svg>
</template>

<script setup>
defineProps({ name: { type: String, default: 'library' } })

const paths = {
  brand: 'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm3 5 6 4-6 4V8Z',
  home: 'm3 10 9-7 9 7v10h-6v-7H9v7H3V10Z',
  library: 'M3 4h5v16H3V4Zm7 0h5v16h-5V4Zm7 0 4 15',
  live: 'M5 6h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Zm3-4 4 4 4-4m-6 8 5 3-5 3v-6Z',
  downloads: 'M12 3v12m-5-5 5 5 5-5M4 17v4h16v-4',
  settings: 'M4 6h16M4 12h16M4 18h16M9 4v4m7 2v4m-8 2v4',
  search: 'M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.5 4.5L21 21',
  grid: 'M3 3h7v7H3V3Zm11 0h7v7h-7V3ZM3 14h7v7H3v-7Zm11 0h7v7h-7v-7Z',
  heart: 'M20 5c-3-3-6-1-8 1-2-2-5-4-8-1-5 5 3 11 8 15 5-4 13-10 8-15Z',
  clock: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM12 7v5l3 2',
  remote: 'M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm1 5h6m-6 4h6m-3 5v1',
  arrow: 'm9 5 7 7-7 7',
  plus: 'M12 4v16M4 12h16',
  close: 'm6 6 12 12M6 18 18 6',
  play: 'm9 5 11 7-11 7V5Z',
  info: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM12 11v6m0-10v.01',
  check: 'm5 12 4 4L19 6',
}
</script>
